import { Injectable } from '@angular/core';
import { SVG_ICON_PATHS, DROPDOWN_TYPES } from '../constants/asset-list-actions.constants';

@Injectable({
  providedIn: 'root',
})
export class AssetListDropdownIconService {
  public getDropdownPreIcon(selectedValues: any[], allOptions: any[], hasOptions: boolean = true): string {
    if (!hasOptions || !allOptions?.length) {
      return SVG_ICON_PATHS.UNSELECT;
    }
    if (selectedValues.length === allOptions.length) {
      return SVG_ICON_PATHS.SELECTED;
    }
    return selectedValues?.length ? SVG_ICON_PATHS.FILTERED : SVG_ICON_PATHS.UNSELECT;
  }

  public getProjectDropdownPreIcon(selectedProjectIds: string[], projectOptions: { id: string }[]): string {
    return this.getDropdownPreIcon(selectedProjectIds, projectOptions, projectOptions?.length > 0);
  }

  public getFocusDropdownPreIcon(selectedFocusValues: string[], focusOptions: string[]): string {
    return this.getDropdownPreIcon(selectedFocusValues, focusOptions, focusOptions?.length > 0);
  }

  public getTypeDropdownPreIcon(selectedTypeValues: string[], typeOptions: string[]): string {
    return this.getDropdownPreIcon(selectedTypeValues, typeOptions, typeOptions?.length > 0);
  }

  public getBetsDropdownPreIcon(selectedBetsValues: string[], betsOptions: string[]): string {
    return this.getDropdownPreIcon(selectedBetsValues, betsOptions, betsOptions?.length > 0);
  }

  public getDurationDropdownPreIcon(selectedDurationValues: string[], durationOptions: string[]): string {
    return this.getDropdownPreIcon(selectedDurationValues, durationOptions);
  }

  public getFormatDropdownPreIcon(selectedFormatValues: string[], formatOptions: string[]): string {
    return this.getDropdownPreIcon(selectedFormatValues, formatOptions);
  }

  public getCategoriesDropdownPreIcon(selectedCategoriesValues: string[], categoriesOptions: string[]): string {
    return this.getDropdownPreIcon(selectedCategoriesValues, categoriesOptions);
  }

  public getInUseDropdownPreIcon(selectedInUseValues: string[], inUseOptions: string[]): string {
    return this.getDropdownPreIcon(selectedInUseValues, inUseOptions);
  }

  public getStatusDropdownPreIcon(selectedStatusValues: string[], statusOptions: { value: string }[]): string {
    const allStatusValues: string[] = statusOptions.map((item: { value: string }) => item.value);
    return this.getDropdownPreIcon(selectedStatusValues, allStatusValues);
  }

  public getDropdownIcon(type: string, selectedValues: any[], options: any[]): string {
    switch (type) {
      case DROPDOWN_TYPES.PROJECT:
        return this.getProjectDropdownPreIcon(selectedValues, options);
      case DROPDOWN_TYPES.FOCUS:
        return this.getFocusDropdownPreIcon(selectedValues, options);
      case DROPDOWN_TYPES.TYPE:
        return this.getTypeDropdownPreIcon(selectedValues, options);
      case DROPDOWN_TYPES.BETS:
        return this.getBetsDropdownPreIcon(selectedValues, options);
      case DROPDOWN_TYPES.DURATION:
        return this.getDurationDropdownPreIcon(selectedValues, options);
      case DROPDOWN_TYPES.FORMAT:
        return this.getFormatDropdownPreIcon(selectedValues, options);
      case DROPDOWN_TYPES.CATEGORIES:
        return this.getCategoriesDropdownPreIcon(selectedValues, options);
      case DROPDOWN_TYPES.IN_USE:
        return this.getInUseDropdownPreIcon(selectedValues, options);
      case DROPDOWN_TYPES.STATUS:
        return this.getStatusDropdownPreIcon(selectedValues, options);
      default:
        return SVG_ICON_PATHS.UNSELECT;
    }
  }
}
